import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import { EXPERIMENTS_UPDATED } from 'redux/actionTypes/experiments';
var deleteCellLevelMetadata = function deleteCellLevelMetadata(experimentId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/cellLevelMeta"), {
              method: 'DELETE',
              headers: {
                'Content-Type': 'application/json'
              }
            });
          case 3:
            dispatch({
              type: EXPERIMENTS_UPDATED,
              payload: {
                experimentId: experimentId,
                experiment: {
                  cellLevelMetadata: null
                }
              }
            });
            _context.next = 9;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            handleError(_context.t0, _context.t0.userMessage);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default deleteCellLevelMetadata;